import {noop} from '@benchling/js-utils';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import PrintableWrapper from 'notebook/mediocre/print/PrintableWrapper';
// @ts-expect-error
import ProtocolEditor from 'notebook/protocols/editor/Editor';
import EditorStore from 'notebook/protocols/stores/EditorStore';

// Keep in sync with less/protocol-editor.less:@protocol-editor-base-indent
const PROTOCOL_EDITOR_BASE_INDENT = 40;

class ProtocolPrintableViewConnector extends DataConnector<Props, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [EditorStore];

  enhanceProps(): EnhancedProps {
    // @ts-expect-error ts-migrate(2339) FIXME: getEditorState does not exist on EditorStore
    return {protocol: this.editorStore().getEditorState(this.props.id).protocol};
  }
}

interface Props {
  id: string;
}
interface EnhancedProps {
  protocol?: {
    id: string;
    name: string;
    inEntry?: boolean;
    permissions?: {
      readable: boolean;
    };
  };
}

class ProtocolPrintableView extends React.Component<Props & EnhancedProps> {
  renderEditor = (): JSX.Element | null => {
    if (this.props.protocol == null) {
      return null;
    }
    return (
      <div data-printable-left-margin={PROTOCOL_EDITOR_BASE_INDENT}>
        <ProtocolEditor
          fileId={this.props.id}
          protocol={this.props.protocol}
          locked={true}
          storeState={noop}
          restoreState={noop}
          requestSelection={noop}
          key={this.props.protocol.id}
          viewer={true}
          showPrintMargins={false}
        />
      </div>
    );
  };

  render(): JSX.Element {
    return (
      <PrintableWrapper title={this.props.protocol != null ? this.props.protocol.name : undefined}>
        {this.renderEditor()}
      </PrintableWrapper>
    );
  }
}

export default ProtocolPrintableViewConnector.connect(ProtocolPrintableView);
